import axios from 'axios';
import config from '../config';

const { queryUrl, queryApiKey } = config || {};

export async function fetchThingNames(contains) {
  const response = await axios.get(`${queryUrl}/things`, {
    params: contains ? { contains } : undefined,
    headers: {
      'x-api-key': queryApiKey,
    },
  });

  const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
  return (data && data.thing_names) || [];
}

export default async function fetchQueryResults({
  startTime,
  endTime,
  selectedSensors,
  selectedFacility,
  selectedThingNames,
}) {
  const startUtc = startTime.setZone('utc').toISO();
  const endUtc = endTime.setZone('utc').toISO();

  const payload = {
    sensor_types: selectedSensors,
    datetime_range: {
      start_time: startUtc,
      end_time: endUtc,
    },
  };

  if (selectedThingNames && selectedThingNames.length > 0) {
    payload.thing_names = selectedThingNames;
  }
  if (selectedFacility) {
    payload.facility = selectedFacility;
  }

  const response = await axios.post(`${queryUrl}/direct-query`, payload, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': queryApiKey,
    },
  });

  const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
  return data;
}
